export default __webpack_public_path__ + "static/media/Innenarum-des-hauses.0c0b552a.jpg";